module.exports = __webpack_public_path__ + "img/microphone.9496e48f.svg";